export default __webpack_public_path__ + "static/media/0.e6ade864.svg";